import Feature from "../../../views/Feature";
import FeatureToggle from "../../../views/FeatureToggle";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import FeatureToggleBulkDelete from "../../../views/FeatureToggleUpload/FeatureToggleBulkDelete";

const Features = [
  {
    menuName: MenuNames.FEATURE,
    path: "/feature",
    component: Feature,
    exact: true,
  },
  {
    menuName: MenuNames.FEATURE_TOGGLE,
    path: "/feature-toggle",
    component: FeatureToggle,
    exact: true,
  },
  {
    menuName: MenuNames.FEATURE_TOGGLE,
    path: "/feature-toggle-delete-by-ids",
    component: FeatureToggleBulkDelete,
    exact: true,
  },
];

export default Features;
